// IE 2026 09 12 / ODOO-… (заказ Игоря): поиск по частям и «интеллектуальный» поиск с опечатками.
// Текст поиска с пробелами — набор частей (терминов): каждая должна найтись (в любом порядке), а не вся фраза целиком
// («abk 30» → «Фильтрум таб №30»). Если точно ничего не нашлось — опечатки по СТУПЕНЯМ (уточнение Игоря 12.09): 1) одна
// гласная заменена другой гласной, 2) любая одна буква (замена/пропуск/лишняя — расстояние редактирования 1 до подстроки,
// алгоритм Sellers), 3) две буквы (только у слов от 6 букв), 4) набор «под диктовку» — буквы термина идут в тексте по порядку
// с пропусками (первая в начале слова, разброс не длиннее 2·len+2). Есть результат на ступени — дальше не усложняем; такие
// совпадения подсвечиваются особо (класс *-fuzzy).
// IE 2026 09 14 / ODOO-… (заказ Игоря: ступени 5–6 поиска): 5) свёртка похожих знаков — № ≈ Nº/N° (текст со скрина/OCR: «Упсарин Nº20» ≈ «Упсарин №20»),
// º/°/дефисы/апострофы выпадают, латиница ≈ кириллица по начертанию (c/с, a/а, e/е, o/о, p/р, x/х, y/у, k/к, m/м, t/т, h/н, b/в, i/і), ё ≈ е —
// точное вхождение после свёртки; 6) несколько букв, в т.ч. РАЗНОЕ ЧИСЛО букв (вставки/пропуски/замены по расстоянию редактирования
// с бюджетом от длины: 4–5 букв — 2, 6–8 — 3, дальше треть слова) — на свёрнутых строках; только когда ступени 1–4 пусты.
// Общая логика для быстрого поиска в чипсе селектора (AttrChips) и поиска над таблицей (AttrGrid / check_CHIPS_highlighted).

import { layoutCandidates } from './keyboardLayout'   // IE 2026 09 22 / ODOO-… (заказ Игоря): лестница поиска searchLadder — и раскладка клавиатуры
import { t } from '@/i18n'   // IE 2026 09 23 / ODOO-341407: i18n

// числа словами (набор под диктовку, уточнение Игоря 12.09: «Биогая пять капель» → «БиоГая капли 5мл»): ru / uk / en,
// составные «двадцать пять» → 25, «сто двадцать» → 120, «две тысячи» → 2000. Слово-число заменяется цифрами; кавычки-апострофы
// в украинских числительных (п'ять) нормализуются
const NUM_WORDS = (() => {
    const m = {}
    const add = (words, v) => { for (const w of words.split(' ')) m[w] = v }
    // ru
    add('ноль', 0); add('один одна одно', 1); add('два две', 2); add('три', 3); add('четыре', 4); add('пять', 5); add('шесть', 6); add('семь', 7); add('восемь', 8); add('девять', 9)
    add('десять', 10); add('одиннадцать', 11); add('двенадцать', 12); add('тринадцать', 13); add('четырнадцать', 14); add('пятнадцать', 15); add('шестнадцать', 16); add('семнадцать', 17); add('восемнадцать', 18); add('девятнадцать', 19)
    add('двадцать', 20); add('тридцать', 30); add('сорок', 40); add('пятьдесят', 50); add('шестьдесят', 60); add('семьдесят', 70); add('восемьдесят', 80); add('девяносто', 90)
    add('сто', 100); add('двести', 200); add('триста', 300); add('четыреста', 400); add('пятьсот', 500); add('шестьсот', 600); add('семьсот', 700); add('восемьсот', 800); add('девятьсот', 900)
    // uk
    add('нуль', 0); add('одне', 1); add('дві', 2); add('чотири', 4); add("п'ять", 5); add('шість', 6); add('сім', 7); add('вісім', 8); add("дев'ять", 9)
    add('одинадцять', 11); add('дванадцять', 12); add('тринадцять', 13); add('чотирнадцять', 14); add("п'ятнадцять", 15); add('шістнадцять', 16); add('сімнадцять', 17); add('вісімнадцять', 18); add("дев'ятнадцять", 19)
    add('двадцять', 20); add('тридцять', 30); add("п'ятдесят", 50); add('шістдесят', 60); add('сімдесят', 70); add('вісімдесят', 80); add("дев'яносто", 90)
    add('двісті', 200); add('чотириста', 400); add("п'ятсот", 500); add('шістсот', 600); add('сімсот', 700); add('вісімсот', 800); add("дев'ятсот", 900)
    // en
    add('zero', 0); add('one', 1); add('two', 2); add('three', 3); add('four', 4); add('five', 5); add('six', 6); add('seven', 7); add('eight', 8); add('nine', 9)
    add('ten', 10); add('eleven', 11); add('twelve', 12); add('thirteen', 13); add('fourteen', 14); add('fifteen', 15); add('sixteen', 16); add('seventeen', 17); add('eighteen', 18); add('nineteen', 19)
    add('twenty', 20); add('thirty', 30); add('forty', 40); add('fifty', 50); add('sixty', 60); add('seventy', 70); add('eighty', 80); add('ninety', 90); add('hundred', 100)
    return m
})()
const THOUSAND = new Set(['тысяча', 'тысячи', 'тысяч', 'тисяча', 'тисячі', 'тисяч', 'thousand'])
const normApos = (t) => t.replace(/[\u2019\u02BC\u0060\u00B4]/g, "'")
export function numberWordsToDigits(parts) {
    const out = []
    let cur = null, total = 0
    const flush = () => { if (cur !== null || total) { out.push(String(total + (cur || 0))); cur = null; total = 0 } }
    for (const p0 of parts) {
        const p = normApos(p0)
        if (THOUSAND.has(p)) { if (cur === null && !total) cur = 1; total += (cur || 0) * 1000; cur = 0; continue }
        const v = NUM_WORDS[p]
        if (v === undefined) { flush(); out.push(p0); continue }
        if (cur === null) cur = v
        else if (v === 100 && cur > 0 && cur < 10) cur = cur * 100          // «two hundred»
        else if (v < cur && (cur % 100 === 0 || (cur % 10 === 0 && v < 10))) cur += v   // «сто двадцать», «двадцать пять»
        else { flush(); cur = v }                                             // два числа подряд — отдельные части
    }
    flush()
    return out
}

// части текста поиска (нижний регистр, без пустых; числа словами → цифры)
export function searchTerms(text) {
    return numberWordsToDigits(String(text ?? '').toLowerCase().split(/\s+/).map(t => t.trim()).filter(Boolean))
}

// допуск опечаток для термина: числа и очень короткие термины — без допуска (опечатка в числе — другое число,
// в трёх буквах — другое слово), 4–5 букв — одна, длиннее — две
export function fuzzyK(term) {
    const t = String(term ?? '')
    if (!t || /^[\d.,\-–—:/%№#]+$/.test(t)) return 0
    const n = Array.from(t).length
    if (n <= 3) return 0
    if (n <= 5) return 1
    return 2
}

export const FUZZY_TIERS = 6   // IE 2026 09 14 / ODOO-… (заказ Игоря: ступени 5–6 поиска): + 5 (похожие знаки), 6 (несколько букв, длина может отличаться)
export const FUZZY_TIER_TEXT = {   // IE 2026 09 23 / ODOO-341407: i18n — подписи ступеней геттерами: t() при чтении, после загрузки словаря
    get 1() { return t('one vowel differs') }, get 2() { return t('one letter differs') }, get 3() { return t('up to two letters differ') }, get 4() { return t('some letters skipped') },
    get 5() { return t('look-alike letters and symbols folded (№ ≈ Nº, Latin ≈ Cyrillic)') }, get 6() { return t('several letters differ, the length may differ') },
    get 7() { return t('extra symbol ignored') }, get 8() { return t('one extra letter or digit ignored') } }   // IE 2026 10 02 / ODOO-345043 (заказ Игоря: поиск — лишний символ в запросе): шаги последней ступени (searchLadderExtra — в конце файла)
const isNumeric = (t) => /^[\d.,\-–—:/%№#]+$/.test(t)
// допустима ли ступень для термина: числа и ≤2 букв — никакая; 1–2 — от 4 букв; 3 — от 6; 4 (пропуски) — от 3
export function tierAllowed(term, tier) {
    const t = String(term ?? '')
    if (!t) return false
    const n = Array.from(t).length
    if (tier === 5) return n >= 2               // IE 2026 09 14 / ODOO-… (заказ Игоря: ступени 5–6 поиска): свёртка знаков — и для «числовых» терминов (№20 ≈ Nº20)
    if (isNumeric(t)) return false
    if (tier === 1 || tier === 2) return n >= 4
    if (tier === 3) return n >= 6
    if (tier === 4) return n >= 3
    if (tier === 6) return n >= 4
    return false
}
// IE 2026 09 14 / ODOO-… (заказ Игоря: ступени 5–6 поиска): бюджет ступени 6 (несколько букв, длина может отличаться) по длине термина
export function fuzzyK6(term) {
    const n = Array.from(String(term ?? '')).length
    return n <= 5 ? 2 : n <= 8 ? 3 : Math.ceil(n / 3)
}
// IE 2026 09 14 / ODOO-… (заказ Игоря: ступени 5–6 поиска): свёртка похожих знаков (ступени 5–6): значение '' — знак выпадает; map[i] — индекс исходного символа
// для свёрнутого символа i (подсветка в исходном тексте). Строки — в нижнем регистре
const FOLD = {
    '№': 'n', 'º': '', '°': '', 'ª': '',                                   // номер, знаки градуса/порядка (OCR, копия со скрина: Nº20 ≈ №20)
    'a': 'а', 'c': 'с', 'e': 'е', 'o': 'о', 'p': 'р', 'x': 'х', 'y': 'у',  // латиница ≈ кириллица по начертанию
    'k': 'к', 'm': 'м', 't': 'т', 'h': 'н', 'b': 'в', 'i': 'і',
    'ё': 'е', 'ґ': 'г',
    '-': '', '–': '', '—': '', "'": '', '\u2019': '', '\u02BC': '', '`': '',   // дефисы и апострофы
}
const _foldCache = new Map()   // IE 2026 09 14 / ODOO-… (заказ Игоря: ступени 5–6 поиска): свёртка текста кэшируется (один текст сворачивается на каждый термин и ступень)
export function foldText(text) {
    const src = String(text ?? '')
    const hit = _foldCache.get(src)
    if (hit) return hit
    let out = ''
    const map = []
    for (let i = 0; i < src.length; i++) {
        const ch = src[i], r = FOLD[ch]
        if (r === undefined) { out += ch; map.push(i) }
        else if (r !== '') { out += r; map.push(i) }
    }
    const res = { text: out, map, changed: out !== src }
    if (_foldCache.size > 20000) _foldCache.clear()
    _foldCache.set(src, res)
    return res
}
const unfoldRange = (r, fold) => (r && fold.map.length ? { ...r, start: fold.map[Math.min(r.start, fold.map.length - 1)], end: fold.map[Math.max(0, Math.min(r.end, fold.map.length) - 1)] + 1 } : r)
// старшая допустимая ступень термина (0 — только точно)
export function fuzzyMaxTier(term) {
    for (let t = FUZZY_TIERS; t >= 1; t--) if (tierAllowed(term, t)) return t
    return 0
}

// ступень 4 (набор под диктовку): буквы термина встречаются в тексте по порядку с пропусками — первая на границе слова,
// весь разброс не длиннее 2·len+2 (жадно); возвращает позиции совпавших букв для подсветки
export function subseqFind(text, term) {
    const T = String(text ?? ''), P = String(term ?? '')
    const m = P.length, n = T.length
    if (m < 3 || n < m) return null
    const isWordChar = (ch) => /[\p{L}\p{N}]/u.test(ch)
    const window = m * 2 + 2
    for (let s = 0; s <= n - m; s++) {
        if (T[s] !== P[0]) continue
        if (s > 0 && isWordChar(T[s - 1])) continue
        const pos = [s]
        for (let i = 1, j = s + 1; i < m && j < n && j < s + window; j++) { if (T[j] === P[i]) { pos.push(j); i++ } }
        if (pos.length === m) return { start: s, end: pos[m - 1] + 1, dist: m, positions: pos }
    }
    return null
}

const VOWELS = new Set('аеёиоуыэюяіїєaeiouy')
// ступень 1: подстрока текста, отличающаяся от термина ровно одной буквой, причём гласной на месте гласной
export function vowelSubstFind(text, term) {
    const T = String(text ?? ''), P = String(term ?? '')
    const m = P.length, n = T.length
    if (m < 2 || n < m) return null
    for (let s = 0; s + m <= n; s++) {
        let bad = 0, ok = true
        for (let i = 0; i < m; i++) {
            const a = P[i], b = T[s + i]
            if (a === b) continue
            if (bad || !VOWELS.has(a) || !VOWELS.has(b)) { ok = false; break }
            bad = 1
        }
        if (ok && bad) return { start: s, end: s + m, dist: 1 }
    }
    return null
}

// вхождение термина на ступени tier (0 — точно): точное всегда первым, затем ступени по возрастанию до tier (каждая — если допустима для термина)
export function fuzzyFindTier(text, term, tier = 0) {
    const T = String(text ?? ''), P = String(term ?? '')
    if (!P || !T) return null
    const ix = T.indexOf(P)
    if (ix >= 0) return { start: ix, end: ix + P.length, dist: 0 }
    const t = tier === true ? FUZZY_TIERS : (tier | 0)
    if (t <= 0) return null
    let r = null
    if (t >= 1 && tierAllowed(P, 1)) r = vowelSubstFind(T, P)
    if (!r && t >= 2 && tierAllowed(P, 2)) r = fuzzyFind(T, P, 1)
    if (!r && t >= 3 && tierAllowed(P, 3)) r = fuzzyFind(T, P, 2)
    if (!r && t >= 4 && tierAllowed(P, 4)) r = subseqFind(T, P)
    // IE 2026 09 14 / ODOO-… (заказ Игоря: ступени 5–6 поиска): ступени 5–6 — на свёрнутых строках (№ ≈ Nº, латиница ≈ кириллица), позиции возвращаются в исходный текст
    if (!r && t >= 5 && tierAllowed(P, 5)) {
        const fT = foldText(T), fP = foldText(P).text
        if (fP && (fT.changed || fP !== P)) {
            const ix = fT.text.indexOf(fP)
            if (ix >= 0) r = unfoldRange({ start: ix, end: ix + fP.length, dist: 1 }, fT)
        }
        if (!r && t >= 6 && tierAllowed(P, 6) && fP) {
            const k = fuzzyK6(fP)
            r = unfoldRange(fuzzyFind(fT.text, fP, k), fT)
        }
    }
    return r
}
// диапазоны подсветки вхождения: у ступени 4 — каждая совпавшая буква отдельно
const rangesOf = (r) => r.positions ? r.positions.map(p => ({ start: p, end: p + 1, fuzzy: true })) : [{ start: r.start, end: r.end, fuzzy: r.dist > 0 }]

// приближённое вхождение: минимальное расстояние редактирования между term и какой-либо подстрокой text (свободные
// начало и конец подстроки); возвращает { start, end, dist } лучшего вхождения (минимальная дистанция, при равной —
// более раннее) или null, если ближе k не нашлось. text и term — в одном регистре (нижнем)
export function fuzzyFind(text, term, k = 0) {
    const T = String(text ?? ''), P = String(term ?? '')
    const m = P.length, n = T.length
    if (!m || !n) return null
    const ix = T.indexOf(P)
    if (ix >= 0) return { start: ix, end: ix + m, dist: 0 }
    if (!k || k >= m) return null
    // IE 2026 09 14 / ODOO-… (заказ Игоря: ступени 5–6 поиска): отсечки до DP — текст короче термина больше чем на k; в тексте нет ≥ k+1 «классов букв» термина
    if (n < m - k) return null
    if (missingClasses(P, T) > k) return null
    if (_dp[0].length < m + 1) for (let b = 0; b < 4; b++) _dp[b] = new Int32Array(m + 64)   // буферы без аллокаций на каждый вызов
    let prevC = _dp[0], prevS = _dp[1], curC = _dp[2], curS = _dp[3]
    for (let i = 0; i <= m; i++) { prevC[i] = i; prevS[i] = 0 }
    let best = null
    for (let j = 1; j <= n; j++) {
        curC[0] = 0; curS[0] = j   // свободное начало подстроки
        const tc = T.charCodeAt(j - 1)
        for (let i = 1; i <= m; i++) {
            let c = prevC[i - 1] + (P.charCodeAt(i - 1) === tc ? 0 : 1), s = prevS[i - 1]   // совпадение / замена
            const del = prevC[i] + 1   // лишний символ в тексте
            if (del < c) { c = del; s = prevS[i] }
            const ins = curC[i - 1] + 1   // пропущенный символ в тексте
            if (ins < c) { c = ins; s = curS[i - 1] }
            curC[i] = c; curS[i] = s
        }
        if (curC[m] <= k && (!best || curC[m] < best.dist)) best = { start: curS[m], end: j, dist: curC[m] }
        const tC = prevC; prevC = curC; curC = tC
        const tS = prevS; prevS = curS; curS = tS
    }
    return best
}

// IE 2026 09 14 / ODOO-… (заказ Игоря: ступени 5–6 поиска): кэши и отсечки для больших словарей (подбор в чипсе перебирает десятки тысяч названий)
const _dp = [new Int32Array(64), new Int32Array(64), new Int32Array(64), new Int32Array(64)]
const _lowCache = new Map()
export function lowerCached(text) {
    const src = String(text ?? '')
    let v = _lowCache.get(src)
    if (v === undefined) { v = src.toLowerCase(); if (_lowCache.size > 60000) _lowCache.clear(); _lowCache.set(src, v) }
    return v
}
// битовая маска «классов букв» строки (код символа по модулю 31) — нижняя оценка числа правок:
// класс, которого нет в тексте, требует хотя бы одной правки за каждую букву термина этого класса
const _maskCache = new Map()
function classMask(str) {
    let mk = _maskCache.get(str)
    if (mk !== undefined) return mk
    mk = 0
    for (let i = 0; i < str.length; i++) mk |= (1 << (str.charCodeAt(i) % 31))
    if (_maskCache.size > 60000) _maskCache.clear()
    _maskCache.set(str, mk)
    return mk
}
function popcount(x) { x = x - ((x >>> 1) & 0x55555555); x = (x & 0x33333333) + ((x >>> 2) & 0x33333333); return (((x + (x >>> 4)) & 0x0F0F0F0F) * 0x01010101) >>> 24 }
function missingClasses(term, text) { return popcount(classMask(term) & ~classMask(text)) }

// IE 2026 09 14 / ODOO-… (заказ Игоря: ступени 5–6 поиска): вхождение термина ровно на ступени tier (без младших) — для однопроходного перебора ступеней
export function fuzzyFindAt(text, term, tier, prep = null) {
    const T = String(text ?? ''), P = String(term ?? '')
    if (!P || !T || !(prep ? (prep.allowed & (1 << tier)) : tierAllowed(P, tier))) return null
    if (tier === 1) return vowelSubstFind(T, P)
    // IE 2026 09 14 / ODOO-… (заказ Игоря: ступени 5–6 поиска): отсечка q-грамм до DP (лемма: подстрока на расстоянии ≤ k делит с термином не меньше
    // m − 1 − 2k его биграмм; считаем оптимистично — биграмма «есть где-то в тексте»): нет нужного числа биграмм → DP не нужен
    if (tier === 2 || tier === 3) {
        const k = tier - 1
        if (prep && !bigramsEnough(T, prep.bg, prep.len - 1 - 2 * k)) return null
        return fuzzyFind(T, P, k)
    }
    if (tier === 4) return subseqFind(T, P)
    const fT = foldText(T), fP = foldText(P).text
    if (!fP) return null
    if (tier === 5) {
        if (!(fT.changed || fP !== P)) return null
        const ix = fT.text.indexOf(fP)
        return ix >= 0 ? unfoldRange({ start: ix, end: ix + fP.length, dist: 1 }, fT) : null
    }
    if (tier === 6) {
        const k = prep ? prep.k6 : fuzzyK6(fP)
        if (prep && !bigramsEnough(fT.text, prep.bgF, prep.lenF - 1 - 2 * k)) return null
        return unfoldRange(fuzzyFind(fT.text, fP, k), fT)
    }
    return null
}
function bigrams(str) { const out = []; for (let i = 0; i + 1 < str.length; i++) { const b = str.slice(i, i + 2); if (!out.includes(b)) out.push(b) } return out }
function bigramsEnough(text, bg, need) {
    if (need <= 0) return true
    let sh = 0
    for (let i = 0; i < bg.length && sh < need; i++) if (text.indexOf(bg[i]) >= 0) sh++
    return sh >= need
}
// IE 2026 09 14 / ODOO-… (заказ Игоря: ступени 5–6 поиска): термин, подготовленный один раз на проход по словарю (десятки тысяч названий): длина, старшая ступень,
// маска ступеней, свёртка, бюджеты и маски классов букв — без повторных Array.from / свёрток на каждое название
export function prepareTerms(terms) {
    return (terms || []).map(t => {
        const P = String(t ?? '')
        const mt = fuzzyMaxTier(P)
        let allowed = 0
        for (let i = 1; i <= FUZZY_TIERS; i++) if (tierAllowed(P, i)) allowed |= (1 << i)
        const fP = foldText(P).text
        const k6 = fuzzyK6(fP)
        const kMax = mt >= 6 ? k6 : (mt >= 3 ? 2 : (mt >= 1 ? 1 : 0))
        return { t: P, mt, allowed, fP, k6, kMax, maskF: classMask(fP), maskRaw: classMask(P), len: P.length, lenF: fP.length, bg: bigrams(P), bgF: bigrams(fP) }
    })
}
// IE 2026 09 14 / ODOO-… (заказ Игоря: ступени 5–6 поиска): младшая ступень (0 — точно), на которой найдены ВСЕ части: { tier, ranges } или null.
// Один проход: у каждой части ступени перебираются по возрастанию до первой найденной, ступень текста — максимум по частям
export function matchTermsBest(text, terms, maxTier = FUZZY_TIERS) {
    const low = lowerCached(text)
    let tier = 0
    const ranges = []
    const preps = (terms && terms.length && typeof terms[0] === 'object') ? terms : prepareTerms(terms)
    let fT = null, maskT = 0, maskFT = 0, fTdone = false
    for (const prep of preps) {
        const term = prep.t
        let r = null, t = 0
        const ix = low.indexOf(term)
        if (ix >= 0) r = { start: ix, end: ix + term.length, dist: 0 }
        else {
            const mt = Math.min(maxTier | 0, prep.mt)
            if (mt < 1) return null
            // IE 2026 09 14 / ODOO-… (заказ Игоря: ступени 5–6 поиска): отсечки до ступеней — по свёрнутым строкам (самая мягкая ступень 6 допускает k6 правок,
            // ступени 1–4 — не больше двух и все буквы термина на месте): не хватает классов букв / длины → нет ни одной ступени
            if (!fTdone) { fT = foldText(low).text; maskT = classMask(low); maskFT = classMask(fT); fTdone = true }
            const kMax = mt >= 6 ? prep.k6 : (mt >= 3 ? 2 : (mt >= 1 ? 1 : 0))
            if (fT.length < prep.lenF - kMax || popcount(prep.maskF & ~maskFT) > kMax) return null
            const tStart = (popcount(prep.maskRaw & ~maskT) > 2 || low.length < prep.len - 2) ? 5 : 1   // ступени 1–4 невозможны — сразу свёртка
            for (t = tStart; t <= mt && !r; t++) r = fuzzyFindAt(low, term, t, prep)
            if (r) t--
        }
        if (!r) return null
        if (t > tier) tier = t
        ranges.push(...rangesOf(r))
    }
    return { tier, ranges }
}

// все части найдены в тексте (tier — ступень опечаток, 0 — точно): массив вхождений для подсветки или null
export function matchTerms(text, terms, tier = 0) {
    const low = lowerCached(text)
    const out = []
    for (const term of terms || []) {
        const r = fuzzyFindTier(low, term, tier)
        if (!r) return null
        out.push(...rangesOf(r))
    }
    return out
}

// вхождения тех частей, что есть в тексте (для подсветки ячейки, где найдена лишь часть терминов); пусто — ничего нет
export function foundTerms(text, terms, tier = 0) {
    const low = lowerCached(text)
    const out = []
    for (const term of terms || []) {
        const r = fuzzyFindTier(low, term, tier)
        if (r) out.push(...rangesOf(r))
    }
    return out
}

// обернуть вхождения в text тегами (пересечения сливаются; fuzzy-вхождение получает fuzzyCls);
// escape — экранировать текст (для v-html из сырой строки); без него — вставка тегов в исходный текст (ячейка грида)
export function highlightRanges(text, ranges, { tag = 'span', cls = 'wj-state-match', fuzzyCls = 'wj-state-match-fuzzy', escape = false } = {}) {
    const src = String(text ?? '')
    const esc = escape ? (s) => s.replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/>/g, '&gt;') : (s) => s
    const rs = (ranges || []).filter(r => r && r.end > r.start).map(r => ({ start: Math.max(0, r.start), end: Math.min(src.length, r.end), fuzzy: !!r.fuzzy })).sort((a, b) => a.start - b.start)
    const merged = []
    for (const r of rs) {
        const last = merged[merged.length - 1]
        if (last && r.start <= last.end) { last.end = Math.max(last.end, r.end); last.fuzzy = last.fuzzy || r.fuzzy }
        else merged.push({ ...r })
    }
    let html = '', pos = 0
    for (const r of merged) {
        html += esc(src.slice(pos, r.start))
        html += `<${tag} class="${cls}${r.fuzzy ? ' ' + fuzzyCls : ''}">${esc(src.slice(r.start, r.end))}</${tag}>`
        pos = r.end
    }
    html += esc(src.slice(pos))
    return html
}

// ---- IE 2026 09 21 / ODOO-… (замечание Игоря со скрином Purchase Balance: «если есть полное вхождение с учётом пробелов, например при поиске "Impexpharm LLC",
// то не нужно показывать варианты для частичного поиска по словам, разделённым пробелом, например здесь на скрине — лишнее "Vaga-Farm LLC"») ----
// ФРАЗА ЦЕЛИКОМ ГЛАВНЕЕ ЧАСТЕЙ. Текст поиска из нескольких слов сначала ищется как фраза: слова в заданном порядке, между ними — пробелы (один или несколько,
// как в данных: «Zeytun  Pharmaceuticals» с двумя пробелами находится по «zeytun pharmaceuticals»). Фраза нашлась хоть где-то в данных — части по отдельности
// не ищутся, не подсвечиваются и в счётчик не идут; фразы нет — прежний поиск по частям и дальше ступени опечаток. Это нулевая ступень той же лестницы
// «есть результат на ступени — дальше не усложняем». Решение «есть ли фраза в данных» принимает хозяин (AttrGrid.searchPhrase_decide), здесь — чистая логика.
const _phraseCache = new Map()
// фраза текста поиска: { words, text, re, reI } либо null (одно слово, выражение «= …», отбор по стилям «style:…», служебный чипс «>> …»)
export function searchPhrase(text) {
    const src = String(text ?? '').trim()
    let hit = _phraseCache.get(src)
    if (hit !== undefined) return hit
    hit = null
    if (src && !src.startsWith('=') && !src.startsWith('style:') && !src.startsWith('>> ')) {
        const words = src.toLowerCase().split(/\s+/).filter(Boolean)
        if (words.length >= 2) {
            const source = words.map(w => w.replace(/[.*+?^${}()|[\]\\]/g, '\\$&')).join('\\s+')
            // re — по тексту в нижнем регистре (отбор, подсветка, счётчик); reI — регистронезависимое, по СЫРОМУ тексту: проход «есть ли фраза в данных» по десяткам
            // тысяч строк не приводит каждую строку к нижнему регистру (замер: кэш lowerCached на уникальных значениях списка 10 тыс. строк стоил 0,76 с)
            hit = { words, text: words.join(' '), re: new RegExp(source), reI: new RegExp(source, 'i') }
        }
    }
    if (_phraseCache.size > 500) _phraseCache.clear()
    _phraseCache.set(src, hit)
    return hit
}
// вхождение фразы в текст (текст — в нижнем регистре): { start, end, dist: 0 } либо null
export function phraseFind(textLower, phrase) {
    const T = String(textLower ?? '')
    if (!phrase || !T || T.indexOf(phrase.words[0]) < 0) return null
    const m = phrase.re.exec(T)
    return m ? { start: m.index, end: m.index + m[0].length, dist: 0 } : null
}
// диапазон подсветки фразы в ячейке (как foundTerms — первое вхождение); пусто — фразы в тексте нет
export function phraseRanges(text, phrase) {
    const r = phraseFind(lowerCached(text), phrase)
    return r ? [{ start: r.start, end: r.end, fuzzy: false }] : []
}
// есть ли фраза в СЫРОМ тексте (без приведения регистра) — для прохода по данным
export function phraseTest(text, phrase) {
    return !!phrase && typeof text === 'string' && text.length >= phrase.text.length && phrase.reI.test(text)
}

// ---- IE 2026 09 22 / ODOO-… (заказ Игоря 22.09: поиск в панелях функций — «те же правила, что и при поиске по чипсу-поиска в таблице: лояльность к регистру,
// языку, поиск с ошибками, учёт пробела; желательно, чтобы это была та же функция; подсвечивать найденные части») ----
// ЛЕСТНИЦА ПОИСКА ПО СПИСКУ СТРОК В ПАМЯТИ — тот же порядок ступеней, что у чипса поиска грида (AttrGrid.apply_CHIPS → searchPhrase_decide /
// gridSearch_hasTerms) и подбора в чипсе селектора (AttrChips.chipPick_scorer), на тех же примитивах: 0) фраза целиком (текст из нескольких слов нашёлся
// с пробелами хоть в одной строке списка — считается только она, части по отдельности не ищутся), 1) части (все слова, в любом порядке, без учёта
// регистра), 2) те же части в другой раскладке клавиатуры (EN ↔ RU, RU ↔ UK, смешанный текст), 3) ступени опечаток 1…6 (на каждой — как набрано, затем
// другая раскладка; 5 — латиница ≈ кириллица по начертанию, № ≈ Nº). Есть результат на ступени — дальше не усложняем. Решение принимается по ВСЕМУ списку
// (как у грида — по всем строкам данных) и применяется матчером к каждой строке: test(text) → диапазоны подсветки (для highlightRanges) либо null.
// Панели функций (сотни пунктов) проходят синхронно; словари в десятки тысяч строк остаются на порционном проходе чипса (chipPick_recompute)
// IE 2026 09 24 / ODOO-5800 (Igor: поиск в форме ячейки «должен отрабатывать с учетом ошибок и других подходов, которые мы используем при поиске по таблице»):
// элемент списка — строка ЛИБО массив ячеек (строка таблицы: подпись и значение паспорта, метрика с пояснениями, документ Ганта с типом / статусом). Как у грида
// (apply_CHIPS / gridSearch_hasTerms): каждая часть ищется в ЛЮБОЙ ячейке строки (AND по строке), фраза целиком — в одной ячейке. testRow(cells) → диапазоны
// подсветки по ячейкам (как check_CHIPS_highlighted: в каждой ячейке — найденные в ней части), выровненные по индексам cells, либо null. Для строк-текстов
// (панели функций) всё как было: test(text)
// IE 2026 10 02 / ODOO-345043 (заказ Игоря: поиск — лишний символ в запросе): прежняя лестница — тело не менялось, имя searchLadderBase; searchLadder (в конце файла) = она + последняя ступень «лишний символ»
export function searchLadderBase(texts, query, { maxTier = FUZZY_TIERS, phrase = true, layout = true } = {}) {
    const q = String(query ?? '').trim()
    const list = Array.isArray(texts) ? texts : []
    const res = { query: q, text: q, terms: [], conv: '', tier: 0, phrase: null, found: false, test: null, testRow: null, lang: '' }   // IE 2026 09 25: lang — ступень «на другом языке» (searchLadderOther)
    const cellsAll = (item) => (Array.isArray(item) ? item : [item])   // IE 2026 09 24 / ODOO-5800: ячейки строки (строка-текст — одна ячейка)
    const none = (item) => cellsAll(item).map(() => [])                 // IE 2026 09 24 / ODOO-5800: строка проходит, подсвечивать нечего
    if (!q) { res.found = true; res.test = () => []; res.testRow = none; return res }   // пустой запрос — проходит всё, подсвечивать нечего
    // IE 2026 09 24 / ODOO-5800: перебор строк списка — по их непустым ячейкам (строка-текст — одна ячейка, как было)
    const some = (fn) => { for (let i = 0; i < list.length; i++) { const cells = rowCells(list[i]); if (cells.length && fn(cells)) return true } return false }
    // 0) фраза целиком
    const ph = phrase ? searchPhrase(q) : null
    if (ph && some(cells => cells.some(t => phraseTest(t, ph)))) {
        res.phrase = ph; res.found = true
        res.test = (text) => { const r = phraseRanges(text, ph); return r.length ? r : null }
        res.testRow = (item) => { const rs = cellsAll(item).map(c => (typeof c === 'string' && c) ? phraseRangesAll(c, ph) : []); return rs.some(r => r.length) ? rs : null }   // IE 2026 09 24 / ODOO-5800
        return res
    }
    const asTyped = searchTerms(q)
    if (!asTyped.length) { res.found = true; res.test = () => []; res.testRow = none; return res }
    const cands = layout ? layoutCandidates(q).map(c => ({ conv: c, terms: searchTerms(c) })).filter(c => c.terms.length) : []
    const use = (terms, conv, tier) => {
        res.terms = terms; res.conv = conv; res.text = conv || q; res.tier = tier; res.found = true
        res.test = (text) => matchTerms(text, terms, tier)
        // IE 2026 09 24 / ODOO-5800: строка из ячеек — все части найдены (каждая хоть в какой-то ячейке); подсветка — найденные в каждой ячейке части, ВСЕ вхождения
        // (ячейка формы — целое значение строки с повторами: «⚡Автозаплановано» у трёх отгрузок; прежний поиск формы помечал каждое)
        res.testRow = (item) => rowMatchTerms(rowCells(item), terms, tier) ? cellsAll(item).map(c => (typeof c === 'string' && c) ? foundTermsAll(c, terms, tier) : []) : null
        return res
    }
    // 1) части как набрано, 2) части в другой раскладке
    if (some(cells => rowMatchTerms(cells, asTyped, 0))) return use(asTyped, '', 0)
    for (const c of cands) if (some(cells => rowMatchTerms(cells, c.terms, 0))) return use(c.terms, c.conv, 0)
    // 3) ступени опечаток: на каждой — как набрано, затем другая раскладка
    const top = Math.min(maxTier | 0, Math.max(0, ...asTyped.map(fuzzyMaxTier), ...cands.map(c => Math.max(0, ...c.terms.map(fuzzyMaxTier)))))
    for (let tier = 1; tier <= top; tier++) {
        if (some(cells => rowMatchTerms(cells, asTyped, tier))) return use(asTyped, '', tier)
        for (const c of cands) if (some(cells => rowMatchTerms(cells, c.terms, tier))) return use(c.terms, c.conv, tier)
    }
    res.terms = asTyped; res.test = () => null; res.testRow = () => null   // ничего не нашлось — не проходит ни одна строка
    return res
}
// ---- IE 2026 09 25 / ODOO-… (замечание Игоря 25.09: «если поиск не дал списка … поиск по позициям только на другом языке — по их названиям на других языках,
// не на том, на котором они отображены; текущий язык украинский, а я вбиваю на английской раскладке — есть смысл посмотреть среди англоязычных названий») ----
// СТУПЕНЬ «НА ДРУГОМ ЯЗЫКЕ»: когда ВСЯ лестница на текущем языке (фраза, части, раскладка, опечатки) не дала ни одной строки — та же лестница по названиям тех же
// строк на других языках интерфейса, языки по очереди (английский первым — база всех ключей): первый язык с результатом побеждает. namesByLang — [{ lang, texts }]
// (texts — названия строк на этом языке; строки без названия пропущены) либо ФУНКЦИЯ, возвращающая такой список: считается только при промахе (имена собираются
// лениво — словари i18n, ответ бэка). Ответ — матчер той же лестницы с полем lang (test(text) — по имени строки на ТОМ языке); ничего не нашлось — null
// IE 2026 09 25: на чужих именах опечатки — только до ступени 3 (одна гласная / одна буква / до двух букв): ступени 4 (пропуски) и 6 (несколько букв, длина
// может отличаться) на трёх корпусах давали ложные совпадения (замер dev, uk: «qqqq» → «Show SQL query texts», «Filters» → «My profile»)
export const OTHER_LANG_MAX_TIER = 3
export function searchLadderOther(namesByLang, query, opts = {}) {
    const q = String(query ?? '').trim()
    if (!q) return null
    const lists = typeof namesByLang === 'function' ? namesByLang() : namesByLang
    const o = { ...opts, maxTier: Math.min(OTHER_LANG_MAX_TIER, (opts && opts.maxTier !== undefined) ? (opts.maxTier | 0) : OTHER_LANG_MAX_TIER) }
    for (const nl of (Array.isArray(lists) ? lists : [])) {
        if (!nl || !nl.lang) continue
        // IE 2026 09 28 / ODOO-… (заказ Игоря: поиск в формах-меню по статусам): строка списка — текст либо массив ячеек (имя пункта и имя его статуса на этом языке), как у searchLadder
        const texts = (nl.texts || []).filter(t => (typeof t === 'string' && t) || (Array.isArray(t) && t.some(c => typeof c === 'string' && c)))
        if (!texts.length) continue
        const m = searchLadderBase(texts, q, o)   // IE 2026 10 02 / ODOO-345043 (заказ Игоря: поиск — лишний символ в запросе): названия на других языках — прежней лестницей (последняя ступень — отдельно, searchLadderExtra)
        if (m.found) { m.lang = nl.lang; return m }
    }
    return null
}
// лестница текущего языка, при промахе — ступень «на другом языке» (searchLadderOther); матчер без lang — обычный, с lang — по именам того языка.
// Без namesByLang — прежняя лестница как есть
export function searchLadderWithNames(texts, query, namesByLang, opts = {}) {
    const m = searchLadderBase(texts, query, opts)
    if (m.found) return m
    const o = namesByLang ? searchLadderOther(namesByLang, query, opts) : null
    if (o) return o
    // IE 2026 10 02 / ODOO-345043 (заказ Игоря: поиск — лишний символ в запросе): последняя ступень — после названий на других языках (текущий язык, затем те же названия); opts.extra === false — без неё
    if (opts && opts.extra === false) return m
    return searchLadderExtra(texts, query, opts, namesByLang) || m
}

// IE 2026 09 24 / ODOO-5800 (поиск в форме ячейки — как по таблице): непустые ячейки строки списка (строка-текст — одна ячейка)
function rowCells(item) {
    if (typeof item === 'string') return item ? [item] : []
    return Array.isArray(item) ? item.filter(c => typeof c === 'string' && c) : []
}
// IE 2026 09 24 / ODOO-5800: все части найдены в строке — каждая хоть в какой-то её ячейке, на ступени tier (0 — точно); для одной ячейки — то же, что matchTerms
export function rowMatchTerms(cells, terms, tier = 0) {
    if (!terms || !terms.length) return false
    const lows = (cells || []).map(lowerCached)
    return terms.every(term => lows.some(low => !!fuzzyFindTier(low, term, tier)))
}
// IE 2026 09 24 / ODOO-5800: как foundTerms, но ВСЕ вхождения каждой части (поиск продолжается за концом найденного, та же ступень: точные — первыми)
export function foundTermsAll(text, terms, tier = 0) {
    const low = lowerCached(text)
    const out = []
    for (const term of terms || []) {
        let pos = 0
        for (let k = 0; k < 200 && pos < low.length; k++) {
            const r = fuzzyFindTier(pos ? low.slice(pos) : low, term, tier)
            if (!r) break
            for (const x of rangesOf(r)) out.push({ ...x, start: x.start + pos, end: x.end + pos })
            pos += Math.max(1, r.end)
        }
    }
    return out
}
// IE 2026 09 24 / ODOO-5800: как phraseRanges, но все вхождения фразы
export function phraseRangesAll(text, phrase) {
    const out = []
    if (!phrase) return out
    const low = lowerCached(text), re = new RegExp(phrase.re.source, 'g')
    let m
    while ((m = re.exec(low))) { out.push({ start: m.index, end: m.index + m[0].length, fuzzy: false }); if (!m[0].length) re.lastIndex++ }
    return out
}

// ---- IE 2026 09 24 / ODOO-5800 (Igor: поиск в форме ячейки — как по таблице): числа с разделителями разрядов ----
// Грид ищет по СЫРЫМ значениям ячеек («1080» находит 1080), а у формы ячейки есть только показанный текст «1 080». Вариант текста без разделителей внутри
// числа: пробел / NBSP / узкий NBSP / тонкий / цифровой пробел между группами по три цифры выпадает; map[i] — индекс исходного символа (подсветка в исходном
// тексте, как у foldText). Числа через пробел с другим числом цифр («24 09 2026», «2026 09») не склеиваются
const DIGIT_GROUP_RE = /(?<!\d)\d{1,3}(?:[ \u00a0\u202f\u2009\u2007]\d{3})+(?!\d)/g
export function ungroupDigits(text) {
    const src = String(text ?? '')
    if (!/\d[ \u00a0\u202f\u2009\u2007]\d/.test(src)) return { text: src, map: null, changed: false }
    let out = '', pos = 0, m
    const map = []
    DIGIT_GROUP_RE.lastIndex = 0
    while ((m = DIGIT_GROUP_RE.exec(src))) {
        for (let i = pos; i < m.index; i++) { out += src[i]; map.push(i) }
        for (let i = m.index; i < m.index + m[0].length; i++) { const ch = src[i]; if (ch >= '0' && ch <= '9') { out += ch; map.push(i) } }
        pos = m.index + m[0].length
    }
    for (let i = pos; i < src.length; i++) { out += src[i]; map.push(i) }
    return out === src ? { text: src, map: null, changed: false } : { text: out, map, changed: true }
}

// ---- IE 2026 10 02 / ODOO-345043 (заказ Игоря: поиск — лишний символ в запросе) ----
// Igor 02.10 (скрины dev02, подбор в чипсе «Об'єкт»: «Локоид мазь 30г ©» → «Немає збігів», «Локоид мазь 30г » → найдено): «доработай поиск, если не найдено …
// то возможно пользователь добавил лишний символ». Замер: лишняя часть «©» — из одного знака, ступени опечаток ей не положены (tierAllowed), точно её нет →
// пуст весь запрос. ПОСЛЕДНЯЯ СТУПЕНЬ ЛЕСТНИЦЫ — только когда всё прежнее (фраза, части, другая раскладка, опечатки 1…6, названия на других языках) не дало
// НИЧЕГО: результаты запросов, которые что-то находят, не меняются (FUZZY_TIERS и функции ступеней 1…6 не тронуты). Два шага, номера — следом за FUZZY_TIERS:
//  7 «extra symbol ignored»: части без единой буквы и цифры (©, ®, ™, знаки препинания, кавычки, слэши) отбрасываются, такие же знаки по краям части срезаются
//    («30г®» → «30г», «"Локоид» → «Локоид»); очищенный текст (не меньше EXTRA_MIN_CLEAN значимых знаков) идёт по обычной лестнице хозяина;
//  8 «one extra letter or digit ignored»: в запросе от EXTRA_MIN_QUERY значимых знаков ровно ОДНА часть лишняя на один знак — отдельная часть из одного знака
//    («… 30г 1», «… 30г я») отбрасывается либо из части убирается один знак; все остальные части обязаны найтись ТОЧНО. Знак убирается только у частей, которым
//    ступень 2 «одна буква» не положена (числа — «№200», части короче 4 знаков): у прочих лишнюю букву уже находит ступень 2 (расстояние редактирования 1 до
//    подстроки: «Локкоид», «30гг»), и раз она пуста — пуст и укороченный вариант; дубль не строится. Сначала текст как набран, затем очищенный (шаг 7 + шаг 8).
// Цена: шаг 7 — ещё один проход обычной лестницы по очищенному тексту; шаг 8 — ОДИН проход «какая часть не нашлась» (indexOf на часть — matchExtraChar), а не
// проход на каждый вариант. Найденное на этих шагах помечается приближённым (как ступени опечаток). Выключатель fe.search.extraSymbolTier (дефолт вкл.) читают
// хозяева: AttrChips (подбор в чипсе, знак ≈ чипса поиска), AttrGrid (поиск по таблице), Dropdown (форма ячейки), MenuPanel (панели-меню), AttrMD (текст инструкций)
export const EXTRA_TIER_SYMBOL = 7
export const EXTRA_TIER_CHAR = 8
export const EXTRA_MIN_CLEAN = 2       // шаг 7: в очищенном тексте не меньше двух значимых знаков (одна буква находила бы всё подряд)
export const EXTRA_MIN_QUERY = 4       // шаг 8: только запросы от четырёх значимых знаков
export const EXTRA_MAX_VARIANTS = 24   // шаг 8: потолок числа вариантов текста
const SIG_RE = /[\p{L}\p{N}\p{M}]/u    // значимый знак — буква или цифра (и диакритика разложенной буквы)
const sigCount = (s) => { let n = 0; for (const ch of Array.from(String(s ?? ''))) if (SIG_RE.test(ch)) n++; return n }
const isServiceQuery = (q) => q.startsWith('=') || q.startsWith('style:') || q.startsWith('>> ')   // выражение, отбор по стилям, служебный чипс — как у searchPhrase
// подпись последней ступени: шаг (7 | 8) и ступень опечаток внутри шага 7 («extra symbol ignored, one letter differs»)
export function extraTierText(step, inner = 0) {
    const a = FUZZY_TIER_TEXT[step] || '', b = (inner >= 1 && inner <= FUZZY_TIERS) ? FUZZY_TIER_TEXT[inner] : ''
    return b ? a + ', ' + b : a
}
// срезать с краёв части всё, что не буква и не цифра ('' — в части нет ни буквы, ни цифры); lead / trail — с какого края срезать
function trimSymbols(tok, lead = true, trail = true) {
    const src = String(tok ?? ''), ch = Array.from(src)
    let a = 0, b = ch.length
    if (lead) while (a < b && !SIG_RE.test(ch[a])) a++
    if (trail) while (b > a && !SIG_RE.test(ch[b - 1])) b--
    return (a === 0 && b === ch.length) ? src : ch.slice(a, b).join('')
}
// шаг 7: текст без лишних символов — { text, changed, sig }: части без букв и цифр выброшены, края частей очищены (регистр и знаки ВНУТРИ частей — как были);
// changed — очистка что-то убрала; sig — число значимых знаков в очищенном тексте. Служебные запросы («= …», «style:…», «>> …») не чистятся
export function searchExtraClean(text) {
    const src = String(text ?? '').trim()
    const out = []
    let changed = false
    for (const tok of (src ? src.split(/\s+/) : [])) {
        const c = trimSymbols(tok)
        if (c !== tok) changed = true
        if (c) out.push(c)
    }
    const res = out.join(' ')
    return { text: res, changed: changed && !isServiceQuery(src), sig: sigCount(res) }
}
// тексты шага 8: как набран, затем очищенный (лишние символы и один лишний знак разом)
const extraBases = (q, c) => ((c.changed && c.text && c.text !== q) ? [q, c.text] : [q])
// шаг 8: подготовка текста — { terms, vars: [{ i, v, text }], byTerm } либо null (шаг тексту не положен). terms — части (searchTerms); вариант k: часть i
// отброшена (v === '') либо заменена на v (без одного знака); text — текст запроса в этом варианте (исходный регистр, когда части соответствуют словам один
// к одному); byTerm[i] — номера вариантов части i. Порядок вариантов = порядок предпочтения: сначала отдельные части из одного знака (с конца запроса), затем
// знаки частей (части с конца, знаки с конца); одинаковые тексты — один раз; не больше EXTRA_MAX_VARIANTS
export function prepareExtraChar(text) {
    const src = String(text ?? '').trim()
    if (!src || isServiceQuery(src) || sigCount(src) < EXTRA_MIN_QUERY) return null
    const terms = searchTerms(src)
    if (!terms.length) return null
    const toks = src.split(/\s+/)
    const shown = (toks.length === terms.length && terms.every((t, i) => toks[i].toLowerCase() === t)) ? toks : terms   // числа словами склеиваются в цифры — тогда части как есть
    const vars = [], byTerm = terms.map(() => []), seen = new Set()
    const add = (i, v, shownV) => {
        if (vars.length >= EXTRA_MAX_VARIANTS) return
        const parts = shown.slice()
        if (v) parts[i] = shownV; else parts.splice(i, 1)
        if (!parts.length) return
        const txt = parts.join(' '), key = txt.toLowerCase()
        if (seen.has(key)) return
        seen.add(key)
        byTerm[i].push(vars.length)
        vars.push({ i, v, text: txt })
    }
    // 1) отдельная часть из одного значимого знака
    if (terms.length > 1) for (let i = terms.length - 1; i >= 0; i--) if (Array.from(terms[i]).length === 1 && SIG_RE.test(terms[i])) add(i, '', '')
    // 2) один знак из части, которой ступень 2 не положена (число либо короче 4 знаков; от 3 знаков — в укороченной остаётся не меньше двух значимых).
    //    Знаки части, набранные пользователем, остаются («№200» → «№20», а не «20»): срезается только край, который открыл убранный знак («12-3» → «12»)
    for (let i = terms.length - 1; i >= 0; i--) {
        const ch = Array.from(terms[i])
        if (ch.length < 3 || tierAllowed(terms[i], 2)) continue
        const chS = Array.from(shown[i]), same = chS.length === ch.length
        for (let p = ch.length - 1; p >= 0; p--) {
            const cut = (arr) => trimSymbols(arr.filter((_, k) => k !== p).join(''), p === 0, p === arr.length - 1)
            const v = cut(ch)
            if (sigCount(v) < 2) continue
            add(i, v, same ? cut(chS) : v)
        }
    }
    return vars.length ? { terms, vars, byTerm } : null
}
// шаг 8 для одной строки: lows — её текст в нижнем регистре (строка) либо тексты её ячеек (массив). Номер сработавшего варианта (меньше — главнее) либо -1:
// ровно одна часть не найдена точно, остальные найдены (каждая — хоть в какой-то ячейке), и для ненайденной подходит вариант (её можно отбросить либо
// найден её вариант без одного знака). Все части найдены — не дело этой ступени (-1)
export function matchExtraChar(lows, P) {
    if (!P) return -1
    const one = typeof lows === 'string'
    const has = (term) => {
        if (one) return lows.indexOf(term) >= 0
        for (let j = 0; j < lows.length; j++) if (lows[j].indexOf(term) >= 0) return true
        return false
    }
    let miss = -1
    for (let i = 0; i < P.terms.length; i++) {
        if (has(P.terms[i])) continue
        if (miss >= 0) return -1
        miss = i
    }
    if (miss < 0) return -1
    const ks = P.byTerm[miss]
    for (let x = 0; x < ks.length; x++) { const v = P.vars[ks[x]].v; if (!v || has(v)) return ks[x] }
    return -1
}
// наборы последней ступени для подбора по словарю (AttrChips.chipPick_extraScorer): шаг 7 — { step, conv, terms, prep } очищенного текста как набрано и в другой
// раскладке (каждый — по обычным ступеням matchTermsBest); шаг 8 — { step, P, ord } (prepareExtraChar; ord — порядок предпочтения набора) текста как набран,
// очищенного и их вариантов в другой раскладке. Пусто — ступень тексту не положена
export function searchExtraSets(text, { layout = true } = {}) {
    const q = String(text ?? '').trim()
    const out = []
    if (!q || isServiceQuery(q)) return out
    const c = searchExtraClean(q)
    const lay = (x) => [x, ...(layout ? layoutCandidates(x) : [])]
    if (c.changed && c.sig >= EXTRA_MIN_CLEAN) {
        for (const x of lay(c.text)) { const terms = searchTerms(x); if (terms.length) out.push({ step: EXTRA_TIER_SYMBOL, conv: x, terms, prep: prepareTerms(terms) }) }
    }
    let ord = 0
    for (const base of extraBases(q, c)) for (const x of lay(base)) { const P = prepareExtraChar(x); if (P) out.push({ step: EXTRA_TIER_CHAR, P, ord: ord++ }) }
    return out
}
// последняя ступень лестницы по списку строк (вызывать, когда searchLadderBase и названия на других языках ничего не дали): матчер той же формы, что у
// searchLadder — query как набран, conv / text — текст, по которому найдено, tier — 7 | 8 (подпись FUZZY_TIER_TEXT / extraTierText), extra — он же, inner —
// ступень опечаток внутри шага 7, test / testRow — диапазоны, все приближённые; ничего — null. namesByLang (как у searchLadderOther) — шаг 7 смотрит и
// названия на других языках
export function searchLadderExtra(texts, query, opts = {}, namesByLang = null) {
    const q = String(query ?? '').trim()
    if (!q || isServiceQuery(q)) return null
    const list = Array.isArray(texts) ? texts : []
    const approx = (rs) => rs.map(r => ({ ...r, fuzzy: true }))
    const wrap = (m, text, step) => {
        const test = m.test, testRow = m.testRow
        return { ...m, query: q, text, conv: text, tier: step, extra: step, inner: m.tier,
            test: (t) => { const r = test(t); return r ? approx(r) : r },
            testRow: (item) => { const rs = testRow(item); return rs ? rs.map(approx) : rs } }
    }
    // 7) лишние символы
    const c = searchExtraClean(q)
    if (c.changed && c.sig >= EXTRA_MIN_CLEAN) {
        let m = searchLadderBase(list, c.text, opts)
        if (!m.found && namesByLang) m = searchLadderOther(namesByLang, c.text, opts)
        if (m && m.found) return wrap(m, m.conv || c.text, EXTRA_TIER_SYMBOL)
    }
    // 8) один лишний знак: текст как набран, затем очищенный; у каждого — как есть, затем другая раскладка; лучший вариант — по всему списку
    for (const base of extraBases(q, c)) {
        for (const x of [base, ...(opts.layout === false ? [] : layoutCandidates(base))]) {
            const P = prepareExtraChar(x)
            if (!P) continue
            let best = -1
            for (let i = 0; i < list.length && best !== 0; i++) {
                const cells = rowCells(list[i])
                if (!cells.length) continue
                const k = matchExtraChar(cells.map(lowerCached), P)
                if (k >= 0 && (best < 0 || k < best)) best = k
            }
            if (best < 0) continue
            const m = searchLadderBase(list, P.vars[best].text, { ...opts, maxTier: 0, layout: false })
            if (m.found) return wrap(m, P.vars[best].text, EXTRA_TIER_CHAR)
        }
    }
    return null
}
// ЛЕСТНИЦА ПОИСКА: прежние ступени (searchLadderBase — тело не менялось), при промахе — последняя ступень «лишний символ»; opts.extra === false — без неё
export function searchLadder(texts, query, opts = {}) {
    const m = searchLadderBase(texts, query, opts)
    if (m.found || (opts && opts.extra === false)) return m
    return searchLadderExtra(texts, query, opts) || m
}
